import React from "react";
import { Link } from "react-router-dom";

const PrefrencesUpdated = () => {
  return (
    <div className="container navMarginMobile mydashboard">
      <div className="row">
        <div className="col-12 mt-4 mb-4">
          <h1>We've updated your preferences.</h1>
          <Link to="/vehiclehistory/dashboard" className="linkstyle">
            Click here to return to your dashboard.
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrefrencesUpdated;
